export class NINOHelper {
    static NINORegExp = new RegExp(
        "^(?!BG)(?!FY)(?!GB)(?!KN)(?!NK)(?!PZ)(?!OO)(?!TN)(?!NT)(?!ZZ)[A-Z]*[^DFIQUV][A-Z]*[^DFIOQUV][0-9]{6}[A-D ]$"
    );
    static IsNINOFormatCorrect(data: string): boolean {
        if (data?.length == 8) {
            data = data + " ";
        }
        return this.NINORegExp.test(data);
    }
}
